
    import { Options, Vue } from 'vue-class-component';

    @Options<ApTable>({
        props: {
            isLoading: Boolean,
            rows: [Array],
            keySelector: {
                type: Function,
                required: true,
            },
            headerClass: [String, Object, Array],
            rowClass: [String, Object, Array, Function],
        },
    })
    export default class ApTable extends Vue {
        readonly rows!: any[];
        readonly isLoading!: boolean;
        readonly keySelector!: (row: any) => void;
        readonly headerClass!: string | object | string[];
        readonly rowClass!: string | object | string[] | ((row: any) => string | object | string[]);

        get hasHeader() {
            return !!this.$slots.header;
        }

        mounted() {
            (this.$refs.tableBody as HTMLElement)?.addEventListener('scroll', this.handleScroll);
        }

        rowClassInner(row: any) {
            const classes: any[] = [];

            if (typeof this.rowClass === 'function') {
                classes.push(this.rowClass(row));
            } else {
                classes.push(this.rowClass);
            }

            if (this.isLoading) {
                classes.push('blurred');
            }

            return classes.join(' ');
        }

        handleScroll(e: Event) {
            if (this.isLoading) return;
            var el = e.target as HTMLElement;
            (window as any).el = el;
            const untillBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
            if (untillBottom >= 0 && untillBottom < 10) {
                this.$emit('on-infinite-scroll');
            }
        }
    }
